export const TALKYCO_SET_USER = 'TALKYCO_SET_USER';
export const TALKYCO_RESET = 'TALKYCO_RESET';

export const ANALYTICS_IDENTITY = 'ANALYTICS_IDENTITY';
export const ANALYTICS_RESET = 'ANALYTICS_RESET';
